export default "__VITE_ASSET__FzcZurjJ__"